module.exports = "<div class=\"resource-item-content resource-reel-item\">\r\n    <h3>Personalised training</h3>    \r\n    <p>Justis offers free online training to all customers.</p>\r\n    <p><a class=\"training-email\" href=\"mailto:traininglondon@vlex.com\">traininglondon@vlex.com</a> | +44 (0)20 7284 8083</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/partials/overview-resource-training.html
// module id = 386
// module chunks = 1